import { module } from 'angular';
import { HomeLayoutService } from './home-layout.service';
import Home from './home.component';

export default module('app.routes.home', [])
	.component('home', Home)

	.service('HomeLayoutService', HomeLayoutService)
	.name;
